import { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

import { ButtonGroup } from "react-bootstrap";
import { FileEarmarkPdf, FiletypeCsv, Justify, SortDown, SortUp } from "react-bootstrap-icons";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";

import { api } from "../../../services/Api";
import IPreAlertaQtdPendente from "../interfaces/IPreAlertaQtdPendente";

import { CSVLink } from "react-csv";
import { dateTimeStringToISOFormat, montaMenssagemRetornoErroPromiseAllSettled } from "../../../../src/util/FuncoesComuns";
import ToastCustomizado from "../../../components/Toast";
import { AuthContext } from '../../../store/AuthContext';
import downloadResumoPdf from "../ListaUnitizadorUnidadeData/relatorios/resumoPdf";
import { AlertaExpedicaoContext } from "../contextsAlerta/AlertaExpedicao";
import { ATRIBUTOS_FILTRO_RELATORIO_RESUMO, ATRIBUTOS_FILTRO_RELATORIO_RESUMO_CSV, CEPZERO } from "../utils/Constants";
import { aplicarFiltro } from "../utils/Filtros";
import { Mensagem } from "../utils/mensagem";
import "./index.css";
import EctCaixasObjeto from '../../../assets/img/objeto.svg';

const ListaExpedicaoPendente = () => {

  const columns = [
    { label: "#", accessor: "#", sortable: false, className: "text-center primeira-coluna", classNameData: "text-center" },
    { label: "Data", accessor: "dataExpedicao", sortable: true, className: "", classNameData: "" },
    { label: "Qtd Unitizadores", accessor: "qtdUnitizadores", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Objetos", accessor: "qtdObjetos", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Pendentes", accessor: "qtdObjetosPendentes", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Conf. Local", accessor: "qtdObjetosConferidosLocal", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Conf. Nacional", accessor: "qtdObjetosConferidosNacional", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Faltantes", accessor: "qtdObjetosFaltantes", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Qtd Excluídos", accessor: "qtdObjetosExcluidos", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Ação", accessor: "acao", sortable: false, className: "text-center", classNameData: "text-center" },
  ];

  const navigate = useNavigate();
  const didMountRef = useRef(false);
  const divTable = useRef<null | HTMLInputElement>(null);
  const [filtro, setFiltro] = useState<string>('');
  const { user } = useContext(AuthContext);
  const [linhaClicada, setLinhaClicada ] = useState("")
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");

  const {
    key,
    setKey,
    keyTabTipoCarga, setKeyTabTipoCarga,
    setCodSroUnidadeOrigem,
    setDataSelecionada,
    configuracao,
    setConfiguracao,
    dimensoes, setDimensoes,
    setShowSpinner,
    listaExpedicaoPendente,
    setListaExpedicaoPendente
  } = useContext(AlertaExpedicaoContext)

  const [ show, setShow ] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-expedicao' });
  const [listaExpedicaoPendenteFiltrada, setListaExpedicaoPendenteFiltrada] = useState<IPreAlertaQtdPendente[]>([]);

  useEffect(() => {
    didMountRef.current = false;
    setShow(() => false);
    setDataSelecionada(('1900-01-01'))
    setCodSroUnidadeOrigem(()=> CEPZERO);

    consultaResumoAlertasUnidade();

    window.addEventListener('resize', handleResize);

    return () => {
      didMountRef.current = false;
      setShowSpinner(()=>false)
      window.removeEventListener('resize', handleResize);
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {

    if (!didMountRef.current) {
      return; // 🚫 Não executa na montagem inicial
    }
    
    if(key === 'resumo') {
      setShowSpinner(()=>true);
      setCodSroUnidadeOrigem(()=> CEPZERO);
      consultaResumoAlertasUnidade();
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => {
        setCodSroUnidadeOrigem(()=> CEPZERO);
        setShowSpinner(()=>false)
        window.removeEventListener('resize', handleResize);
      }
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[key])

  const consultaResumoAlertasUnidade = () => {
      if(user?.unidadeSro.codigoSro) {

        (async function () {

          const [lista] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas/resumo-data/${user?.unidadeSro.codigoSro}`)]);

          if (lista.status === 'fulfilled') {

            setListaExpedicaoPendente(lista.value.data);

            setListaExpedicaoPendenteFiltrada(lista.value.data)

            setMensagem({ delay: 5000, tipo: 'info', texto: `Ok : Resumo unitizadores recuperado com sucesso.`, url: '/alerta-expedicao' });
            setShow(() => true);
          } else {
            setListaExpedicaoPendente([]);
            setListaExpedicaoPendenteFiltrada([])
            setMensagem({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(lista,'Erro ao chamar /v1/expedicoes-pre-alertas/resumo-data/{codigoSro} - Rejeitado.'), url: '/erro' });
          }
          didMountRef.current = true;
          setShowSpinner(() => false);
        })();

    } else {
        setListaExpedicaoPendente([]);
        setListaExpedicaoPendenteFiltrada([])
        setMensagem({ delay: 5000, tipo: 'warning', texto: `Acesse Alterar Unidade para selecionar a Unidade de trabalho!`, url: '/erro' });
        setShowSpinner(() => false);
        navigate("/erro");
    }
  }

  const handleResize = () => {
    if(dimensoes.height <= 0) {
      const el = document.getElementById('container-principal');
      const d = {
        width: el ? el.offsetWidth : 0,
        height: el ? el.offsetHeight : 0
      }
      setDimensoes(()=>d);
    }
  };

  const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    setFiltro(event.target.value)
    if (event.target.value && event.target.value !== '' && event.target.value.length > 1) {
      let res = aplicarFiltro(listaExpedicaoPendente,ATRIBUTOS_FILTRO_RELATORIO_RESUMO,event.target.value)
      setListaExpedicaoPendenteFiltrada(res)
    } else {
      setListaExpedicaoPendenteFiltrada(listaExpedicaoPendente)
    }
  }

  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  }

  const execute = (e: any, data: any, i: number, linha: string) => {
    if(keyTabTipoCarga !== 'urg') setKeyTabTipoCarga(() => 'urg');
    setCodSroUnidadeOrigem(()=>CEPZERO);
    setDataSelecionada(()=>data.dataExpedicao);
    setConfiguracao({ ...configuracao, rowResClicada: Number(data.dataExpedicao.replaceAll(' ', '').replaceAll('/', '').replaceAll('-', '').replaceAll(':', '').replaceAll('.', '')) })
    setLinhaClicada(linha);
    setKey(()=>'objetos');
  }

  const handleSorting = (sortField: string | number, sortOrder: string) => {

    if (sortField) {
        const sorted = [...listaExpedicaoPendenteFiltrada].sort((a, b) => {

            if ((a as Record<string, any>)[sortField] === null) return 1;
            if ((b as Record<string, any>)[sortField] === null) return -1;
            if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;

            //Caso específico de data no formato dd/mm/aaaa faz este sort
            if(sortField === 'dataExpedicao') {
              return sortOrder === "asc" ? new Date(dateTimeStringToISOFormat((a as Record<string, any>)[sortField].toString().concat(' 00:00:00'))).getTime() - new Date(dateTimeStringToISOFormat((b as Record<string, any>)[sortField].toString().concat(' 00:00:00'))).getTime() : new Date(dateTimeStringToISOFormat((b as Record<string, any>)[sortField].toString().concat(' 00:00:00'))).getTime() - new Date(dateTimeStringToISOFormat((a as Record<string, any>)[sortField].toString().concat(' 00:00:00'))).getTime();
            }else{
              return (
                (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
                    numeric: true,
                }) * (sortOrder === "asc" ? 1 : -1)
              );
            }
        });

        setListaExpedicaoPendenteFiltrada(sorted);
    }
  };


  return (

    <>

      <Form className="border rounded p-2 mb-3">

        <Form.Group as={Row} controlId="formListaExpedicaoPendent">
          <Col sm={12} lg={6} xl={4} >
            <Form.Control
              type="text"
              placeholder="Filtrar"
              title="Digite algo para filtrar."
              value={filtro}
              onChange={setFiltroInput}
            />
          </Col>
          <Col sm={12} lg={6} xl={{ span: 4, offset: 4 }}>
          <ButtonGroup className='mb-2 w-100 h-100'>
                {listaExpedicaoPendenteFiltrada.length > 0 ?
                  <CSVLink headers={ATRIBUTOS_FILTRO_RELATORIO_RESUMO_CSV} data={listaExpedicaoPendenteFiltrada} separator={';'} filename={"resumo.csv"} className="btn btn-primary" type="button"><FiletypeCsv color='white' size={24}/> CSV</CSVLink>
                  :
                  <Button variant="primary" disabled={listaExpedicaoPendenteFiltrada.length === 0}><FiletypeCsv color='white' size={24}/> CSV</Button>
                }
                  <Button variant="primary" disabled={listaExpedicaoPendenteFiltrada.length === 0} onClick={() => downloadResumoPdf(listaExpedicaoPendenteFiltrada,user,filtro)}><FileEarmarkPdf color='red' size={24}/> PDF</Button>
              </ButtonGroup>
          </Col>
        </Form.Group>

      </Form>
            <div ref={divTable} className="mb-5 pb-4">
              <Table id="tabela-lista-expedicao-pendente" responsive striped className="scroll mb-0">
                <thead>
                  <tr>
                    {columns.map(({ label, accessor, sortable, className }) => {

                      const cl = sortable ? sortField === accessor && order === "asc"
                        ? <SortUp className="icon-table-sortable" />
                        : sortField === accessor && order === "desc"
                          ? <SortDown className="icon-table-sortable" />
                          : <Justify className="icon-table-sortable" />
                        : "";

                      return (
                        <th
                          key={accessor}
                          className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
                          onClick={sortable ? () => handleSortingChange(accessor) : undefined}
                        >
                          {cl}
                          {label}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                { listaExpedicaoPendenteFiltrada && listaExpedicaoPendenteFiltrada.length > 0 ? 

                  (<tbody>
                    {listaExpedicaoPendenteFiltrada.map((data: IPreAlertaQtdPendente, index: number) => {

                    let i = ++index;

                      return (

                        <tr id={String(index)} key={index ? index : 0} className={data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'cursor-pointer' : 'cursor-pointer row-selecionada'} onClick={(e) => execute(e, data, i, data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))}>
                          {columns.map(({ accessor, classNameData }) => {

                            const tData = (data as Record<string, any>)[accessor] || (data as Record<string, any>)[accessor] >= 0 ? (data as Record<string, any>)[accessor] : accessor === "#" ? index : "link";

                            return tData !== "link" ? <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                              :
                              <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>
                                <Link to="#" id="btn-bottom-voltar"
                                  className={data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'me-2 text-secondary' : 'me-2 text-success'}
                                  title={`Clique para acessar a aba Objetos de tratamento dos pré-alertas pendentes.`}
                                  role="button" onClick={(e) => execute(e, data, i, data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))}>
                                  <img className="icon-pre-alerta" src={EctCaixasObjeto} alt={`Clique para acessar a aba Objetos de tratamento dos pré-alertas pendentes.`}/>
                                </Link>
                              </td>
                          })}
                        </tr>
                      );
                    })}
                  </tbody>)

                :

                  (<tbody><tr><td colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
                }

              </Table>
            </div>

      { show ?
      <ToastCustomizado
        show={show}
        setShow={setShow}
        mensagem={mensagem && mensagem.texto ? mensagem.texto : undefined}
        tipo={mensagem && mensagem.tipo ? mensagem.tipo : ''}
        delay={mensagem?.delay}
      />
      : null }

    </>
  )
}

export default ListaExpedicaoPendente